var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('dashboard-medico-telemedicina')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-lg-3"},[_c('div',{staticClass:"row justify-content-between"},[_c('h3',{staticClass:"mt-0 mb-2 font-weight-bold text-left"},[_vm._v(" Televet Dashboard ")])])])
}]

export { render, staticRenderFns }